import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const PasswordResetForm = () => {
  const [passwords, setPasswords] = useState({
    password: '',
    confirmPassword: ''
  });
  const reduxEmail = useSelector(state => state.user_slice.email);
  const email = reduxEmail || localStorage.getItem('resetEmail');
  const navigate=useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation checks
    if (!passwords.password || !passwords.confirmPassword) {
      setError('Please fill in both password fields');
      return;
    }

    if (passwords.password !== passwords.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (passwords.password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setIsLoading(true);

    try {
      // Make API request to reset password
      const resetToken = localStorage.getItem('resetToken') || '';
      const cleanToken = resetToken.replace(/^["']|["']$/g, '').trim();
      const response = await axios.post('/auth/reset-password', {
        email: email,
        newPassword: passwords.password,
        resetToken: cleanToken
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.data.success) {
        setSuccess(true);
        setError('');
        setPasswords({ password: '', confirmPassword: '' });
        setTimeout(() => {
            navigate('/login');
        }, 1500);
        // Optionally redirect after successful reset
        // setTimeout(() => window.location.href = '/login', 2000);
      }
    } catch (error) {
      // Handle different types of errors
      if (error.response) {
        // Server responded with error
        switch (error.response.status) {
          case 400:
            setError('Invalid password format');
            break;
          case 401:
            setError('Reset token has expired. Please request a new reset link');
            break;
          case 404:
            setError('Reset token not found');
            break;
          default:
            setError('Failed to reset password. Please try again later');
        }
      } else if (error.request) {
        // Network error
        setError('Network error. Please check your connection');
      } else {
        setError('An unexpected error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
        padding: '2rem'
      }}>
        <h2 style={{
          color: '#333',
          marginBottom: '1.5rem',
          textAlign: 'center',
          fontSize: '1.5rem',
          fontWeight: '600'
        }}>
          Reset Password
        </h2>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <input
              type="password"
              name="password"
              placeholder="Enter new password"
              value={passwords.password}
              onChange={handleChange}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '0.75rem',
                borderRadius: '5px',
                border: '1px solid #ddd',
                fontSize: '1rem',
                outline: 'none',
                transition: 'border-color 0.2s',
                marginBottom: '1rem'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '1rem' }}>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm new password"
              value={passwords.confirmPassword}
              onChange={handleChange}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '0.75rem',
                borderRadius: '5px',
                border: '1px solid #ddd',
                fontSize: '1rem',
                outline: 'none',
                transition: 'border-color 0.2s',
                marginBottom: '1rem'
              }}
            />
          </div>
          
          {error && (
            <div style={{
              background: '#ffebee',
              color: '#c62828',
              padding: '0.75rem',
              borderRadius: '5px',
              marginBottom: '1rem',
              fontSize: '0.875rem'
            }}>
              {error}
            </div>
          )}
          
          {success && (
            <div style={{
              background: '#e8f5e9',
              color: '#2e7d32',
              padding: '0.75rem',
              borderRadius: '5px',
              marginBottom: '1rem',
              fontSize: '0.875rem'
            }}>
              Password reset successfully! Redirecting to login...
            </div>
          )}
          
          <button 
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '0.75rem',
              background: isLoading ? '#ccc' : '#FC350B',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            {isLoading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;